<script lang="ts">
  export let style = "";
</script>

<svg viewBox="0 0 384 512" {style}>
  <path
    d="M217.5 256l137.2-137.2c4.7-4.7 4.7-12.3
    0-17l-8.5-8.5c-4.7-4.7-12.3-4.7-17 0L192 230.5 54.8
    93.4c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17L166.5 256 29.4
    393.2c-4.7 4.7-4.7 12.3 0 17l8.5 8.5c4.7 4.7 12.3 4.7 17 0L192 281.5l137.2
    137.2c4.7 4.7 12.3 4.7 17 0l8.5-8.5c4.7-4.7 4.7-12.3 0-17L217.5 256z"
  />
</svg>
